import parentDomain from '../constants';

export const domain = `${parentDomain}/Authentication`;

// action types
export const SET_LOGGED_IN = `${domain}/SET_LOGGED_IN`;
export const SET_LOGGED_OUT = `${domain}/SET_LOGGED_OUT`;
export const START_AUTHENTICATION = `${domain}/START_AUTHENTICATION`;
